<template>
  <div>
    <VerifyIdentityError
      v-if="availableMfaModalities.length === 0"
      class="md:w-480 md:mx-auto"
      :errorTitle="$t('common.no_contact_info_found')"
      :errorBody="coalescedSupportText('common.contact_health_plan_csr.help')"
      :cancelText="$t('common.return_to_login')"
      @cancel="handleReturn"
    />
    <ModalitySelect
      v-else
      :errorText="errorText"
      :helperText="
        coalescedSupportText(
          'common.contact_health_plan_csr.contact_info_change'
        )
      "
      :mfaPreference="mfaPreference"
      :availableMfaModalities="availableMfaModalities"
      :isBusy="isFetching"
      @continue="handleSubmit"
    />
  </div>
</template>

<script>
import { ModalitySelect, VerifyIdentityError } from '../../../common/mfa'
import { mapActions, mapGetters } from 'vuex'
import { MFA_TYPES } from '@platform-shared/constants'
import { formatPhoneNumber } from '@platform-shared/utils/formatters'
import supportMixin from '../../../mixins/support'
import verifyIdentityMixin from '@platform-shared/mixins/verifyIdentityMixin'
import _orderBy from 'lodash/orderBy'

export default {
  components: {
    VerifyIdentityError,
    ModalitySelect,
  },
  mixins: [supportMixin, verifyIdentityMixin],
  props: {
    isSSORegister: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalityOrder: [MFA_TYPES.SMS, MFA_TYPES.VOICE, MFA_TYPES.EMAIL],
      errorText: '',
    }
  },
  computed: {
    ...mapGetters('registration', ['isFetching', 'mfaPreference']),
    formHasError() {
      return !!this.error
    },
    availableMfaModalities() {
      let availableModalities = []

      Object.values(MFA_TYPES).forEach((mfaType) => {
        switch (mfaType) {
          case MFA_TYPES.SMS:
            if (this.coalesceContactInfo.primarySmsPhone)
              availableModalities.push({
                type: mfaType,
                value: formatPhoneNumber(
                  this.coalesceContactInfo.primarySmsPhone
                ),
              })
            break
          case MFA_TYPES.VOICE:
            if (this.coalesceContactInfo.primaryPhone)
              availableModalities.push({
                type: mfaType,
                value: formatPhoneNumber(this.coalesceContactInfo.primaryPhone),
              })
            break
          case MFA_TYPES.EMAIL:
            if (this.coalesceContactInfo.email)
              availableModalities.push({
                type: mfaType,
                value: this.coalesceContactInfo.email,
              })
            break
        }
      })
      return _orderBy(
        availableModalities,
        [(modality) => this.modalityOrder.indexOf(modality.code)],
        ['asc']
      )
    },
  },
  methods: {
    ...mapActions('registration', ['submitMfaPreference']),
    ...mapActions('member', ['requestMfaCode']),
    ...mapActions(['logout']),
    handleReturn() {
      this.logout()
    },
    handleSubmit(mfaPreference) {
      this.submitMfaPreference(mfaPreference)
        .then(() => {
          this.$emit('next')
        })
        .catch((error) => {
          this.errorText = error.json.message
        })
    },
  },
}
</script>
